export const countries = [
  {
    id: 'DE',
    label: 'Germany',
    code: 'DE',
    pincodeRegex: /^\d{5}$/,
    pincodeFormat: '12345',
  },
  {
    id: 'NL',
    label: 'Netherlands',
    code: 'NL',
    pincodeRegex: /^\d{4}\s?[A-Z]{2}$/i,
    pincodeFormat: '1234 AB',
  },
  {
    id: 'ES',
    label: 'Spain',
    code: 'ES',
    pincodeRegex: /^\d{5}$/,
    pincodeFormat: '12345',
  },
  {
    id: 'FR',
    label: 'France',
    code: 'FR',
    pincodeRegex: /^\d{5}$/,
    pincodeFormat: '12345',
  },
  {
    id: 'IT',
    label: 'Italy',
    code: 'IT',
    pincodeRegex: /^\d{5}$/,
    pincodeFormat: '12345',
  },
  {
    id: 'BE',
    label: 'Belgium',
    code: 'BE',
    pincodeRegex: /^\d{4}$/,
    pincodeFormat: '1234',
  },
  {
    id: 'LU',
    label: 'Luxembourg',
    code: 'LU',
    pincodeRegex: /^(L-)?\d{4}$/i,
    pincodeFormat: '1234',
  },
  {
    id: 'AT',
    label: 'Austria',
    code: 'AT',
    pincodeRegex: /^\d{4}$/,
    pincodeFormat: '1234',
  },
  {
    id: 'PT',
    label: 'Portugal',
    code: 'PT',
    pincodeRegex: /^\d{4}-\d{3}$/,
    pincodeFormat: '1234-567',
  },
  {
    id: 'PL',
    label: 'Poland',
    code: 'PL',
    pincodeRegex: /^\d{2}-\d{3}$/,
    pincodeFormat: '12-345',
  },
  {
    id: 'GB',
    label: 'United Kingdom',
    code: 'GB',
    pincodeRegex: /^[A-Z]{1,2}\d{1,2}\s?\d[A-Z]{2}$/i,
    pincodeFormat: 'SW1A 1AA',
  },
];

export const statesByCountry = {
  DE: [
    { id: 'BW', label: 'Baden-Württemberg' },
    { id: 'BY', label: 'Bavaria' },
    { id: 'BE', label: 'Berlin' },
    { id: 'BB', label: 'Brandenburg' },
    { id: 'HB', label: 'Bremen' },
    { id: 'HH', label: 'Hamburg' },
    { id: 'HE', label: 'Hesse' },
    { id: 'MV', label: 'Mecklenburg-Vorpommern' },
    { id: 'NI', label: 'Lower Saxony' },
    { id: 'NW', label: 'North Rhine-Westphalia' },
    { id: 'RP', label: 'Rhineland-Palatinate' },
    { id: 'SL', label: 'Saarland' },
    { id: 'SN', label: 'Saxony' },
    { id: 'ST', label: 'Saxony-Anhalt' },
    { id: 'SH', label: 'Schleswig-Holstein' },
    { id: 'TH', label: 'Thuringia' },
  ],
  NL: [
    { id: 'DR', label: 'Drenthe' },
    { id: 'FL', label: 'Flevoland' },
    { id: 'FR', label: 'Friesland' },
    { id: 'GE', label: 'Gelderland' },
    { id: 'GR', label: 'Groningen' },
    { id: 'LI', label: 'Limburg' },
    { id: 'NB', label: 'North Brabant' },
    { id: 'NH', label: 'North Holland' },
    { id: 'OV', label: 'Overijssel' },
    { id: 'UT', label: 'Utrecht' },
    { id: 'ZE', label: 'Zeeland' },
    { id: 'ZH', label: 'South Holland' },
  ],
  LU: [
    { id: 'CA', label: 'Capellen' },
    { id: 'CL', label: 'Clervaux' },
    { id: 'DI', label: 'Diekirch' },
    { id: 'EC', label: 'Echternach' },
    { id: 'ES', label: 'Esch-sur-Alzette' },
    { id: 'GR', label: 'Grevenmacher' },
    { id: 'LU', label: 'Luxembourg' },
    { id: 'ME', label: 'Mersch' },
    { id: 'RD', label: 'Redange' },
    { id: 'RM', label: 'Remich' },
    { id: 'VD', label: 'Vianden' },
    { id: 'WI', label: 'Wiltz' },
  ],
  ES: [
    { id: 'AN', label: 'Andalusia' },
    { id: 'AR', label: 'Aragon' },
    { id: 'AS', label: 'Asturias' },
    { id: 'IB', label: 'Balearic Islands' },
    { id: 'PV', label: 'Basque Country' },
    { id: 'CN', label: 'Canary Islands' },
    { id: 'CB', label: 'Cantabria' },
    { id: 'CL', label: 'Castile and León' },
    { id: 'CM', label: 'Castilla-La Mancha' },
    { id: 'CT', label: 'Catalonia' },
    { id: 'EX', label: 'Extremadura' },
    { id: 'GA', label: 'Galicia' },
    { id: 'MD', label: 'Madrid' },
    { id: 'MC', label: 'Murcia' },
    { id: 'NC', label: 'Navarre' },
    { id: 'RI', label: 'La Rioja' },
    { id: 'VC', label: 'Valencia' },
  ],
  FR: [
    { id: 'ARA', label: 'Auvergne-Rhône-Alpes' },
    { id: 'BFC', label: 'Bourgogne-Franche-Comté' },
    { id: 'BRE', label: 'Brittany' },
    { id: 'CVL', label: 'Centre-Val de Loire' },
    { id: 'COR', label: 'Corsica' },
    { id: 'GES', label: 'Grand Est' },
    { id: 'HDF', label: 'Hauts-de-France' },
    { id: 'IDF', label: 'Île-de-France' },
    { id: 'NOR', label: 'Normandy' },
    { id: 'NAQ', label: 'Nouvelle-Aquitaine' },
    { id: 'OCC', label: 'Occitanie' },
    { id: 'PDL', label: 'Pays de la Loire' },
    { id: 'PAC', label: "Provence-Alpes-Côte d'Azur" },
  ],
  IT: [
    { id: 'ABR', label: 'Abruzzo' },
    { id: 'BAS', label: 'Basilicata' },
    { id: 'CAL', label: 'Calabria' },
    { id: 'CAM', label: 'Campania' },
    { id: 'EMR', label: 'Emilia-Romagna' },
    { id: 'FVG', label: 'Friuli-Venezia Giulia' },
    { id: 'LAZ', label: 'Lazio' },
    { id: 'LIG', label: 'Liguria' },
    { id: 'LOM', label: 'Lombardy' },
    { id: 'MAR', label: 'Marche' },
    { id: 'MOL', label: 'Molise' },
    { id: 'PIE', label: 'Piedmont' },
    { id: 'PUG', label: 'Apulia' },
    { id: 'SAR', label: 'Sardinia' },
    { id: 'SIC', label: 'Sicily' },
    { id: 'TOS', label: 'Tuscany' },
    { id: 'TAA', label: 'Trentino-Alto Adige' },
    { id: 'UMB', label: 'Umbria' },
    { id: 'VDA', label: 'Aosta Valley' },
    { id: 'VEN', label: 'Veneto' },
  ],
  BE: [
    { id: 'BRU', label: 'Brussels' },
    { id: 'VLG', label: 'Flanders' },
    { id: 'WAL', label: 'Wallonia' },
  ],
  AT: [
    { id: 'BUR', label: 'Burgenland' },
    { id: 'KAR', label: 'Carinthia' },
    { id: 'NOE', label: 'Lower Austria' },
    { id: 'OOE', label: 'Upper Austria' },
    { id: 'SAL', label: 'Salzburg' },
    { id: 'STE', label: 'Styria' },
    { id: 'TIR', label: 'Tyrol' },
    { id: 'VOR', label: 'Vorarlberg' },
    { id: 'WIE', label: 'Vienna' },
  ],
  PT: [
    { id: 'AV', label: 'Aveiro' },
    { id: 'BE', label: 'Beja' },
    { id: 'BR', label: 'Braga' },
    { id: 'BA', label: 'Bragança' },
    { id: 'CB', label: 'Castelo Branco' },
    { id: 'CO', label: 'Coimbra' },
    { id: 'EV', label: 'Évora' },
    { id: 'FA', label: 'Faro' },
    { id: 'GU', label: 'Guarda' },
    { id: 'LE', label: 'Leiria' },
    { id: 'LI', label: 'Lisbon' },
    { id: 'PO', label: 'Portalegre' },
    { id: 'PR', label: 'Porto' },
    { id: 'SA', label: 'Santarém' },
    { id: 'SE', label: 'Setúbal' },
    { id: 'VC', label: 'Viana do Castelo' },
    { id: 'VR', label: 'Vila Real' },
    { id: 'VI', label: 'Viseu' },
  ],
  PL: [
    { id: 'DS', label: 'Lower Silesia' },
    { id: 'KP', label: 'Kuyavia-Pomerania' },
    { id: 'LU', label: 'Lublin' },
    { id: 'LB', label: 'Lubusz' },
    { id: 'LD', label: 'Łódź' },
    { id: 'MA', label: 'Lesser Poland' },
    { id: 'MZ', label: 'Masovia' },
    { id: 'OP', label: 'Opole' },
    { id: 'PK', label: 'Subcarpathia' },
    { id: 'PD', label: 'Podlaskie' },
    { id: 'PM', label: 'Pomerania' },
    { id: 'SL', label: 'Silesia' },
    { id: 'SK', label: 'Świętokrzyskie' },
    { id: 'WN', label: 'Warmia-Masuria' },
    { id: 'WP', label: 'Greater Poland' },
    { id: 'ZP', label: 'West Pomerania' },
  ],
  GB: [
    { id: 'ENG', label: 'England' },
    { id: 'SCT', label: 'Scotland' },
    { id: 'WLS', label: 'Wales' },
    { id: 'NIR', label: 'Northern Ireland' },
  ],
};

export const validatePincode = (pincode, countryCode) => {
  if (!pincode || !countryCode) return false;

  const country = countries.find((c) => c.code === countryCode);
  if (!country) return false;

  return country.pincodeRegex.test(pincode.trim());
};

export const getPincodeFormat = (countryCode) => {
  const country = countries.find((c) => c.code === countryCode);
  return country ? country.pincodeFormat : '';
};
